import { usePlatformCapabilities } from "../capability/usePlatformCapabilities";

/**
 * Whether the current user may select the "Whole platform" scope — i.e. drop
 * the organization context and view the current platform's data platform-wide.
 *
 * True when the viewer holds ANY capability on the platform's PLATFORM node.
 * Since the connection cutover that set includes connection-conferred
 * capabilities (a viewer reaching this platform through an active platform
 * connection gets the caveated, typically read-only, keys the connection
 * admits), so read-only connection viewers can enter platform-only mode too.
 * An empty set — no grants, unresolved platform, or a BE without the field —
 * fails closed. This is deliberately wider than `useCanAccessPlatformSettings`
 * (`PLATFORM_SETTINGS:WRITE`): selecting the scope is a read affordance, not a
 * platform-management right.
 */
export const useCanSelectWholePlatform = (): boolean => usePlatformCapabilities().size > 0;
